<div class="range-container">
<input type="range" #range [max]="max" [min]="min" step="0.05" [(ngModel)]="value" (ngModelChange)="change()">
<label for="range" #label></label>

</div>
